<template>
    <div>
        <card>
            <tabs type="primary" v-model="currentTab">
                <tab-pane id="general_information" label="General Information">
                    <template slot="header">
                        Custom Fields
                    </template>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <router-link
                                v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].createCustomFields)"
                                :to="{ name: 'custom-fields-create' }">
                                    <el-button type="primary" class="btn btn-primary">
                                        New
                                    </el-button>
                            </router-link>
                        </div>
                    </div>
                    <el-table :data="fields">
                        <el-table-column label="Title" prop="title" min-width="200px"/>
                        <el-table-column label="Name" prop="name" min-width="200px"/>
                        <el-table-column label="Type" prop="type" min-width="200px"/>
                        <el-table-column label="Actions" min-width="300px">
                            <template slot-scope="props">
                                <router-link
                                    v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editCustomFields)"
                                    :to="{ name: 'custom-fields-edit', params: { fieldId: props.row._id } }">
                                        <el-tooltip content="Edit" placement="top">
                                            <el-button class="btn" title="Edit">
                                                <fa :icon="['fas', 'pen']"/>
                                            </el-button>
                                        </el-tooltip>
                                </router-link>
                                <el-tooltip content="Clone" placement="top">
                                    <el-button
                                        @click="clone(props.row._id)"
                                        class="btn ml-1"
                                        title="Clone"
                                        :loading="cloning[props.row._id]">
                                            <fa icon="copy"/>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="Delete" placement="top">
                                    <el-button
                                        @click="remove(props.row._id)"
                                        class="btn btn-danger ml-1"
                                        title="Delete">
                                            <fa :icon="['fas', 'trash']"/>
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </tab-pane>

                <tab-pane id="custom_db_widget" label="Custom Dashboard Widget">
                    <div class="d-flex justify-content-end mb-3">
                        <el-button class="btn btn-primary" @click="createWidget">New</el-button>
                    </div>
                    <el-table :data="widgets">
                        <el-table-column label="Title" prop="title" min-width="200px"/>
                        <el-table-column label="Enabled" prop="enabled" min-width="200px">
                            <template slot-scope="props">
                                {{ props.row.enabled ? 'Yes' : 'No' }}
                            </template>
                        </el-table-column>
                       
                        <el-table-column label="Actions" min-width="300px">
                            <template slot-scope="props">
                                <el-tooltip content="Edit" placement="top">
                                    <el-button 
                                        @click="editWidget(props.row._id)"
                                        class="btn" title="Edit">
                                        <fa :icon="['fas', 'pen']"/>
                                    </el-button>
                                </el-tooltip>

                                <el-tooltip content="Delete" placement="top">
                                    <el-button
                                        @click="deleteWidget(props.row._id)"
                                        class="btn btn-danger ml-1"
                                        title="Delete">
                                            <fa :icon="['fas', 'trash']"/>
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </tab-pane>
            </tabs>
        </card>

        <el-dialog
            title="Field is used in registration types!"
            :visible.sync="showUsedTypes">
                <el-table :data="types">
                    <h3>Used by registration types</h3>
                    <el-table-column label="Name" prop="name"/>
                    <el-table-column label="Actions">
                        <template slot-scope="props">
                            <router-link :to="{ name: 'registration-types-edit', params: { typeId: props.row._id } }">
                                <el-button class="btn">
                                    <fa :icon="['fas', 'pen']"/>
                                </el-button>
                            </router-link>
                        </template>
                    </el-table-column>
                    <h3 class="mt-4">Used by activities</h3>
                    <el-table :data="activities">
                        <el-table-column label="Details" prop="name"/>
                        <el-table-column label="Actions">
                            <template slot-scope="props">
                                <router-link :to="{ name: 'activities-edit', params: { activityId: props.row._id } }">
                                    <el-button class="btn ml-1">
                                        <fa :icon="['fas', 'pen']"/>
                                    </el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                    <h3 class="mt-4">Dependant Fields</h3>
                    <el-table :data="dependantFields">
                        <el-table-column label="Title" prop="title"/>
                        <el-table-column label="Name" prop="name"/>
                        <el-table-column label="Type" prop="type"/>
                        <el-table-column label="Actions">
                            <template slot-scope="props">
                                <router-link :to="{ name: 'custom-fields-edit', params: { fieldId: props.row._id } }">
                                    <el-button class="btn">
                                        <fa :icon="['fas', 'pen']"/>
                                    </el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-table>
                <template slot="footer">
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="danger"
                            @click="remove(forceDeleteId, true)">
                                Delete Anyway
                        </el-button>
                    </div>
                </template>
        </el-dialog>

        <el-dialog
            title="Create New Widget"
            :visible.sync="widgetDialog"
        >
            <el-form :model="widget" label-width="300px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                <el-form-item label="Title*">
                    <el-input v-model="widget.title"/>
                </el-form-item>
                <el-form-item label="Enabled">
                    <el-radio-group v-model="widget.enabled">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="For field"
                >
                    <el-select  v-model="widget.forField">
                        <el-option
                            v-for="(field, index) in fields"
                            v-if="['radio', 'checkboxes', 'list'].includes(field.type)"
                            :key="`field-${field._id}`"
                            :value="field._id"
                            :label="field.title"/>
                        <el-option :value="null" label="None"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Show Values Instead Of Labels">
                    <el-radio-group v-model="widget.showValueInsteadOfLabel">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Combined Counting">
                    <el-radio-group v-model="widget.combinedCount">
                        <el-radio-button :label="false">No</el-radio-button>
                        <el-radio-button :label="true">Yes</el-radio-button>
                    </el-radio-group>
                </el-form-item>

                
                
                <el-form-item
                    v-for="(dependance, index) in widget.dependencies"
                    :key="`dependance-${index}`"
                    :label="`${ index ? 'AND' : '' } Depends on field ${ index ? index + 1 : '' }`">
                        <el-select  v-model="widget.dependencies[index].fieldId">
                            <el-option
                                v-for="(field, index) in fields"
                                v-if="['radio', 'checkboxes', 'list'].includes(field.type)"
                                :key="`field-${field._id}`"
                                :value="field._id"
                                :label="field.title"/>
                            <el-option :value="null" label="None"></el-option>
                        </el-select>
                        <!-- <el-select
                            v-model="widget.dependencies[index].value"
                            style="width: 150px;"
                            placeholder="Depends on Value"
                            class="ml-2">
                                <template v-if="dependance.fieldId">
                                    <el-option
                                        v-for="(value, index) in fields.find(el => el._id == dependance.fieldId).values.split('\n')"
                                        :key="`field-value-${value}`"
                                        :value="value"
                                        :label="value"
                                    />
                                </template>
                                <el-option :value="null" label="None"></el-option>
                        </el-select> -->
                        <el-select
                            v-model="widget.dependencies[index].showValueInsteadOfLabel"
                            style="width: 150px;"
                            placeholder="Show From"
                            class="ml-2">
                                <el-option :value="false" label="Label"></el-option>
                                <el-option :value="true" label="Value"></el-option>
                        </el-select>
                        <el-button
                            class="ml-2"
                            @click="removeDependency(index)">
                                <fa icon="times"/>
                        </el-button>
                </el-form-item>

                <div class="row">
                    <label class="col-sm-2 col-form-label"></label>
                    <div class="col-sm-10">
                        <el-button @click="newDependance()">New Dependance</el-button>
                    </div>
                </div>

                <div class="d-flex justify-content-end">
                    <el-button
                        type="primary"
                        class="btn btn-primary"
                        :loading="saving"
                        @click="saveWidget">
                            Save
                    </el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data () {
        return {
            showUsedTypes: false,
            types: [],
            activities: [],
            dependantFields: [],
            forceDeleteId: null,
            fields: [],
            cloning: {},
            addNewWidget: false,
            widget: {},
            saving: false,
            currentTab: 'general_information',
            rules: {},
            widgets: [],
            widgetDialog: false,
            editingWidget: false

        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ]),

        
    },
    mounted () {
        this.getFields()
        this.fetchWidgets()
    },
    methods: {
        createWidget: function () {
            this.editingWidget = false
            this.widget = {
                title: '',
                enabled: true,
                combinedCount: false,
                showValueInsteadOfLabel: false,
                dependencies: [],
            }
            this.widgetDialog = true  
        },
        editWidget(id){
            this.editingWidget = true
            this.widget = this.widgets.find(w => w._id === id)
            this.widgetDialog = true  
        },

        async saveWidget(){
            if(this.editingWidget){
                try {
                    // patch widget
                    const res = await http.patch('/api/custom-widgets/' + this.widget._id, {
                        eventId: this.$route.params.eventId,
                        title: this.widget.title,
                        enabled: this.widget.enabled,
                        combinedCount: this.widget.combinedCount,
                        forField: this.widget.forField,
                        showValueInsteadOfLabel: this.widget.showValueInsteadOfLabel,
                        dependencies: this.widget.dependencies,
                        
                    });
                    this.widgets = this.widgets.map(w => {
                        if(w._id === this.widget._id){
                            return res.data.widget
                        }
                        return w
                    });
                    this.$notify(res.data.message)
                } catch (error) {
                    this.$store.dispatch('handleErrors', error)
                }
            } else {

                try {
                    // create widget in server
                    const res = await http.post('/api/custom-widgets', {
                        eventId: this.$route.params.eventId,
                        ...this.widget
                    })
                    this.widgets.push(res.data.widget)
                    this.$notify(res.data.message)
                } catch (error) {
                    this.$store.dispatch('handleErrors', error)
                }
            }

            this.widgetDialog = false
        },
        async fetchWidgets(){
            try {
                // await http.get('/api/custom-widgets/calculated', {
                //     params: {
                //         eventId: this.$route.params.eventId
                //     }
                // });

                const res = await http.get('/api/custom-widgets', {
                    params: {
                        eventId: this.$route.params.eventId
                    }
                });
                this.widgets = res.data.widgets
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
        },
        async deleteWidget(id){
            let { value: confirmed } = await swal({
                title: `Are you sure you want to delete the widget?`,
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-default btn-fill'
            })

            if (!confirmed) {
                return
            }

            try {
                const res = await http.delete('/api/custom-widgets/' + id);
                this.$notify(res.data.message)
                this.widgets = this.widgets.filter(w => w._id !== id)
            } catch (error) {
                this.$store.dispatch('handleErrors', error)
            }
        },
        getFields: async function () {
            try {
                const response = await this.$store.dispatch('getAll', {
                    path: 'fields',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
                this.fields = response.data.fields
            } catch (e) {
                console.log('erorr getting fields')
            }
        },
        remove: async function (id, force = false) {
            try {
                if (!force) {
                    let { value: confirmed } = await swal({
                        title: `Are you sure you want to delete the field?`,
                        buttonsStyling: false,
                        showCancelButton: true,
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        confirmButtonClass: 'btn btn-success btn-fill',
                        cancelButtonClass: 'btn btn-default btn-fill'
                    })
    
                    if (!confirmed) {
                        return
                    }
                }

                let query = ''
                if (force) {
                    query = 'force=true'
                }

                const response = await this.$store.dispatch('remove', { path: 'fields', id, query })
                if (response.data.types || response.data.activities || response.data.dependantFields) {
                    this.$notify({ type: 'danger', message: 'Field is used in registration types!' })
                    this.types = response.data.types
                    this.activities = response.data.activities
                    this.dependantFields = response.data.dependantFields
                    this.forceDeleteId = id
                    this.showUsedTypes = true
                } else {
                    this.fields = this.fields.filter(field => field._id !== id)
                    this.showUsedTypes = false
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting field')
            }
        },
        clone: async function (id) {
            this.$set(this.cloning, id, true)
            try {
                const response = await http.post(`/api/fields/${id}/clone`)
                this.$set(this, 'fields', [...this.fields, response.data.field])
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error cloning custom field')
            }
            this.$set(this.cloning, id, false)
        },
        
        newDependance: function () {
            if (!this.widget.dependencies.length || this.widget.dependencies[this.widget.dependencies.length - 1] !== null) {
                this.widget.dependencies.push({
                    fieldId: null,
                    // value: null,
                    showValueInsteadOfLabel: false,
                })
            }
        },
        removeDependency: function (i) {
            this.widget.dependencies = this.widget.dependencies.filter((field, index) => index !== i)
        },
    }
}
</script>
